module.exports = __webpack_public_path__ + "static/media/Camera23.42e5cc80.jpg";